import { useEffect, useState } from 'react';
import { getLegalDoc } from '@shared/api/candidateApi.ts';
import { LEGAL_FALLBACK } from './content/legalFallback.ts';

type LegalState = { loading: true } | { loading: false; content: string; fallback: boolean };

let cache: Promise<string> | null = null;

/** Current legal document, fetched once per page load and shared by the Rules and Register pages. */
export function useLegalDoc(): LegalState & { retry: () => void } {
  const [state, setState] = useState<LegalState>({ loading: true });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let live = true;
    if (!cache) cache = getLegalDoc();
    cache.then(
      (content) => live && setState({ loading: false, content, fallback: false }),
      () => {
        cache = null; // allow retry
        if (live) setState({ loading: false, content: LEGAL_FALLBACK, fallback: true });
      },
    );
    return () => {
      live = false;
    };
  }, [attempt]);

  return {
    ...state,
    retry: () => {
      setState({ loading: true });
      setAttempt((a) => a + 1);
    },
  };
}
